import registry from './registry.json';

export const CARDS = registry;

export const CARD_BY_SLUG = Object.fromEntries(registry.map((card) => [card.slug, card]));

export const ARCANA_ORDER = ['major', 'wands', 'cups', 'swords', 'pentacles'];

export const MEANING_LANGS = ['en', 'es', 'ar', 'zh', 'de', 'pl', 'pt', 'fr'];

export const HUB_PATHS = {
  en: '/tarot-card-meanings/',
  es: '/es/significados-cartas-tarot/',
  ar: '/ar/tarot-card-meanings/',
  zh: '/zh/taluo-pai-yisi/',
  de: '/de/tarot-kartenbedeutungen/',
  pl: '/pl/znaczenia-kart-tarota/',
  pt: '/pt/significados-cartas-tarot/',
  fr: '/fr/significations-cartes-tarot/',
};

const SLUG_FIELD = {
  es: 'esSlug',
  zh: 'zhSlug',
  de: 'deSlug',
  pl: 'plSlug',
  pt: 'ptSlug',
  fr: 'frSlug',
};

const CARDS_BY_LOCAL_SLUG = Object.fromEntries(
  Object.entries(SLUG_FIELD).map(([lang, field]) => [
    lang,
    Object.fromEntries(registry.map((card) => [card[field], card])),
  ]),
);

export function cardPath(card, lang) {
  const field = SLUG_FIELD[lang];
  const slug = field ? card[field] : card.slug;
  return `${HUB_PATHS[lang]}${slug}/`;
}

export function findCardByRouteSlug(routeSlug, lang) {
  const localized = CARDS_BY_LOCAL_SLUG[lang];
  return localized ? localized[routeSlug] : CARD_BY_SLUG[routeSlug];
}

export function findCardByName(name) {
  return registry.find((card) => card.names.en === name) || null;
}

// Content (meanings text) is code-split per language so the main bundle stays small.
const CONTENT_LOADERS = {
  en: () => import('./content.en.json'),
  es: () => import('./content.es.json'),
  ar: () => import('./content.ar.json'),
  zh: () => import('./content.zh.json'),
  de: () => import('./content.de.json'),
  pl: () => import('./content.pl.json'),
  pt: () => import('./content.pt.json'),
  fr: () => import('./content.fr.json'),
};

export function loadContent(lang) {
  const loader = CONTENT_LOADERS[lang] || CONTENT_LOADERS.en;
  return loader().then((mod) => mod.default || mod);
}
